import type {StateCreator} from 'zustand'
import type {CopilotDiffContext} from '@github-ui/diff-lines'
import type {FilesRoutePayload} from '../../page-data/payloads/files'
import type {PullRequestState} from '../../types'

export interface PullRequestSlice {
  pullRequest: {
    state: PullRequestState
    basePath: string
    id: string
    number: number
  }
  copilotDiffContext?: CopilotDiffContext
  pullRequestActions: {
    updatePullRequestState: (pullRequestState: PullRequestState) => void
  }
}
export interface PullRequestSliceOpts {
  pullRequest: FilesRoutePayload['pullRequest']
  copilotDiffContext?: CopilotDiffContext
}

export const createPullRequestSlice =
  ({
    pullRequest,
    copilotDiffContext,
  }: PullRequestSliceOpts): StateCreator<PullRequestSlice, [['zustand/devtools', never]], [], PullRequestSlice> =>
  (set, get) => {
    return {
      pullRequest: {
        state: pullRequest.state,
        basePath: pullRequest.pathName,
        id: pullRequest.id,
        number: pullRequest.number,
      },
      copilotDiffContext,
      pullRequestActions: {
        updatePullRequestState: newPullRequestState => {
          set(
            {
              pullRequest: {
                ...get().pullRequest,
                state: newPullRequestState,
              },
            },
            undefined,
            'pullRequest#updatePullRequestState',
          )
        },
      },
    }
  }
